import React, { useState } from "react";
import Modal from "../../../common/modals";
import "./index.css";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../constants/routes";
import moment from "moment";
import { Event } from "../../types";

interface TourCardProps {
  isCoinSelected: boolean;
  eventData: Event;
}

// const TourCard: React.FC<TourCardProps> = ({ isCoinSelected, eventData }) => {
const TourCard: React.FC<TourCardProps> = ({ eventData }) => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(true);

  const startTime = moment(eventData?.start_time).local();
  const endTime = moment(eventData?.end_time).local();

  const totalDays = endTime.diff(startTime, "days") + 1;
  const nights = totalDays - 1;

  const handleCloseModal = () => {
    setIsModalOpen(false);
    navigate(ROUTES.EVENTS);
  };
  const handleAddToCalendar = () => {
    const startDate = new Date(eventData?.start_time)
      .toISOString()
      .replace(/-|:|\.\d\d\d/g, "");
    const endDate = new Date(eventData?.end_time)
      .toISOString()
      .replace(/-|:|\.\d\d\d/g, "");

    const calendarUrl = `https://www.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
      eventData.title,
    )}&dates=${startDate}/${endDate}&details=${encodeURIComponent(
      eventData.description,
    )}&location=${encodeURIComponent(eventData.location)}&sf=true&output=xml`;

    window.open(calendarUrl, "_blank");
  };

  return (
    <>
      <Modal
        size="large"
        isOpen={isModalOpen}
        closeOnOverlayClick={true}
        customClass="!bg-gray-400 !rounded-[6px] !py-6 h-[75%] md:w-[700px] border-none flex"
        variant="middle"
        onClose={handleCloseModal}
      >
        <div
          className="absolute inset-0 bg-cover object-contain"
          style={{
            background: `url(${eventData.ticket_banner})`,
            filter: "blur(10px)",
            zIndex: -1,
          }}
        ></div>

        <div
          className="absolute top-4 right-4 text-white text-[40px] mt-[-20px] cursor-pointer"
          onClick={handleCloseModal}
        >
          &times;
        </div>

        {/* Modal Container */}
        <div className="flex flex-col justify-center items-center mx-auto rounded-[30px] overflow-hidden  md:w-1/2 w-5/6 max-w-[250px] mt-[30px]">
          <div className="relative w-full h-72 box ">
            <img
              src={eventData.ticket_banner || eventData.banner}
              alt={eventData.title}
              className="w-full h-full object-cover object-top rounded-[30px]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            <div className="absolute bottom-4 w-full flex justify-center text-white">
              <h2 className="text-2xl font-bold text-center bg-gradient-text text-transparent bg-clip-text">
                {eventData.title}
              </h2>
            </div>
          </div>

          {/* Info Section */}
          <div className="w-full px-6 py-3 rounded-b-[30px] bg-gold-gradient box2">
            <div className="flex mb-2 text-[8px]">
              <div className="w-2/3">
                <p className="text-gray-600 w-2/3">DATE</p>
                <p className="text-[12px] font-semibold">
                  {moment(eventData.start_time).format("ddd, MMM D, YYYY")}
                </p>
              </div>
              <div>
                <p className="text-gray-600 text-left">TIMING</p>
                <p className="text-[12px] font-semibold">
                  {moment(eventData.start_time).format("h:mm A")}
                </p>
              </div>
            </div>
            <div className="flex mb-2 text-[8px]">
              <div className="w-2/3">
                <p className="text-gray-600">DURATION</p>
                <p className="text-[12px] font-semibold">
                  {totalDays === 1
                    ? "1 Day"
                    : `${totalDays} Days | ${nights} Nights`}
                </p>
              </div>
              <div className="w-1/3">
                <p className="text-gray-600 text-left min-w-[80px]">
                  MEET LOCATION
                </p>
                <p className="text-[12px] font-semibold">
                  {eventData.location}
                </p>
              </div>
            </div>
            <button
              className={`w-3/4 mx-auto bg-blue-500 text-white py-1 rounded-lg flex items-center justify-center`}
              onClick={
                eventData.event_type === "ONLINE"
                  ? () => {
                      if (eventData.zoom_join_url) {
                        window.location.href = eventData.zoom_join_url;
                      }
                    }
                  : handleAddToCalendar
              }
            >
              {eventData.event_type === "ONLINE"
                ? new Date(eventData.start_time).getTime() -
                    new Date().getTime() <
                  10 * 60 * 1000
                  ? "Join Now"
                  : "Joining link"
                : "Add to Calendar"}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default TourCard;
